import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return <div className={`flex flex-col ${alignment}`} data-id="element-161" data-mp="3k0f9xn4b9z9z">
      {eyebrow ? <span className="mb-3 inline-flex rounded-full border border-brand-red/40 bg-brand-red/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-brand-red" data-id="element-162" data-mp="blesro6m0b11">
          {eyebrow}
        </span> : null}
      <h2 className="font-display text-3xl uppercase leading-[1.05] text-white sm:text-4xl md:text-5xl" data-id="element-163" data-mp="1u0ufjqe9h9h">
        {title}
      </h2>
      {subtitle ? <p className={`mt-4 max-w-2xl text-base leading-relaxed text-white/60 ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-164" data-mp="uipnqwl7kiao">
          {subtitle}
        </p> : null}
    </div>;
}